import { Component } from '@angular/core';

@Component({
  selector: 'app-configurations-standalone-index',
  templateUrl: './configurations-standalone-index.component.html',
  styleUrls: ['./configurations-standalone-index.component.scss'],
  standalone: false
})
export class ConfigurationsStandaloneIndexComponent {
  constructor() {}
}
